
import { useRoutes } from 'react-router-dom';
import Home from './pages/Home';
import App from './App';
import NotFound from './NotFound';
import { Contact } from './pages/Contact';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Blog } from './pages/Blog';
import  BlogDetail  from './pages/BlogDetail';


const RouterIndex = () => {
  const routes = useRoutes([
    {

      element: <App />, // Wrap all routes inside App
      children: [
        { path: "/", element: <Home /> }, // Default route inside IndexLayer
        { path: "/contacts", element: <Contact /> },
        { path: "/about-us", element: <About /> },
        { path: "/services", element: <Services /> },
        { path: "/blog", element: <Blog /> },
        { path: "/:title", element: <BlogDetail /> },
      ],
    },
    { path: "*", element: <NotFound /> },
  ]);

  return routes;
};
export default RouterIndex